/**
 * throw http error
 *
 * taken from https://github.com/sindresorhus/ky
 */
export default class HTTPError extends Error {
  constructor(response) {
    super(response.statusText);
    this.name = "HTTPError";
    this.response = response;
  }
}
